/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable unicorn/numeric-separators-style */
/* eslint-disable prettier/prettier */
import { TFunction } from 'i18next';
import { z } from 'zod';

import { ManageBaseDataKeys, ManageBaseInfoKeys } from '@bvi/api-interfaces/entity/manage-base';


export const buildValidationSchema = (t: TFunction) => {

  const validationFields = {
    //claimant information
    [ManageBaseInfoKeys.ManageBase]: z
      .nativeEnum(ManageBaseDataKeys)
      .nullable()
      .or(z.string()),
  };

  return z.discriminatedUnion('isResolved', [
    // When isResolved is false -> resolution is optional / nullable
    z.object({
      ...validationFields,
      isResolved: z.literal(true),
    }),
  ]);
};

export const defaultValues = {
  [ManageBaseInfoKeys.ManageBase]: '',
};

